/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Local_Submit_ButtonInputs */



/**
* | output |
* | --- |
* | "Embed Captions" |
*
* @param {Embed_Captions_Local_Submit_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_local_submit_button = /** @type {((inputs?: Embed_Captions_Local_Submit_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Local_Submit_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Intégrer les sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitel einbetten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Incorpora sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Встроить субтитры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("嵌入字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕を埋め込む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन एम्बेड करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Incorporar legendas")
	return /** @type {LocalizedString} */ ("Embed Captions")
});